/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { Link, Route } from "react-router-dom";
import { connect } from "react-redux";
import { uniq, sortBy, debounce, toLower } from "lodash";
import Drawer from "rc-drawer";

import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";

import { data } from "jquery";
import {
  Logout,
  Resources as userResources,
  globalSearchResources,
  updateSearchResultData,
  updateGroupInfiniteScroll,
  updateGlobalSearchDeviceStatusWS,
  updateCampaignInfiniteScroll,
  updateContentInfiniteScroll,
  updatePlaylistInfiniteScroll,
  updateCalendarInfiniteScroll,
  updateUserInfiniteScroll
} from "../../features/auth/redux";
import LoginDesc from "./logindesc";
import DeviceMetricsNotification from "./deviceMetricsNotifications";
import {
  ticketUpdateFromWebsocket,
  Resources
} from "../../features/tickets/redux";
import { Resources as notificationResources } from "../../features/notifications/redux/notificationRedux";

import { Get, Post } from "../../constant/thunk";
import { showNotification } from "../modal/toster";

import CustomBreadcrumb from "./breadcrumb";
import { ExitCampaignStudio } from "../../helper/exitCampaignStudioPrompt";
import DesktopBreakpoint from "../../context/desktop_breakpoint";
import PhoneBreakpoint from "../../context/phone_breakpoint";
import GlobalSearchDevice from "./globalSearchDevice";
import GlobalSearchCampaign from "./globalSearchCampaign";
import GlobalSearchContent from "./globalSearchContent";
import GlobalSearchPlaylist from "./globalSearchPlaylist";
import GlobalSearchCalendar from "./globalSearchCalendar";
import GlobalSearchUser from "./globalSearchUser";
import { eventsEnum, Socket } from "../../helper/socket";
import { updateNotificationCountFromWebSocket } from "../../features/notifications/redux";

const links = [
  {
    id: "r-01",
    roles: [
      "General",
      "ContentManager",
      "CampaignManager",
      "CalendarManager",
      "PlaylistManager",
      "NetworkManager",
      "ReportManager",
      "Admin",
      "SuperAdmin"
    ],
    activeLink: "dashboard",
    feature: "Home",
    title: "Dashboard",
    icon: "bx bx-home",
    path: "/dashboard"
  },
  {
    id: "r-02",
    roles: [
      "General",
      "ContentManager",
      "CampaignManager",
      "CalendarManager",
      "PlaylistManager",
      "NetworkManager",
      "Admin",
      "SuperAdmin"
    ],
    activeLink: "content",
    feature: "Content",
    title: "Content",
    icon: "bx bx-book-content",
    path: "/content"
  },
  {
    id: "r-03",
    roles: [
      "PlaylistManager",
      "CampaignManager",
      "CalendarManager",
      "NetworkManager",
      "Admin",
      "SuperAdmin"
    ],
    activeLink: "playlist",
    feature: "Playlist",
    title: "Playlist",
    icon: "bx bxs-playlist",
    path: "/playlist"
  },
  {
    id: "r-04",
    roles: [
      "CampaignManager",
      "CalendarManager",
      "NetworkManager",
      "Admin",
      "SuperAdmin"
    ],
    activeLink: "campaign",
    feature: "Campaign",
    title: "Campaign",
    icon: "bx bx-tv",
    path: "/campaign"
  },
  {
    id: "r-05",
    roles: ["CalendarManager", "NetworkManager", "Admin", "SuperAdmin"],
    activeLink: "calendar",
    feature: "Calendar",
    title: "Calendar",
    icon: "bx bx-calendar",
    path: "/calendar"
  },
  {
    id: "r-06",
    roles: ["NetworkManager", "Admin", "SuperAdmin"],
    activeLink: "networks",
    feature: "Network",
    title: "Network",
    icon: "bx bx-server",
    path: "/networks"
  },
  {
    id: "r-07",
    roles: ["ReportManager", "SuperAdmin"],
    activeLink: "reports",
    feature: "Report",
    title: "Reports",
    icon: "bx bxs-receipt",
    path: "/reports"
  },
  {
    id: "r-08",
    roles: [
      "ContentManager",
      "PlaylistManager",
      "CampaignManager",
      "CalendarManager",
      "Admin",
      "SuperAdmin"
    ],
    activeLink: "archive",
    feature: "Archive",
    title: "Archives",
    icon: "bx bx-box",
    path: "/archives"
  }
  /** Commented Ticket part for a certain time being * */
  // {
  //   id: "r-09",
  //   roles: [
  //     "ContentManager",
  //     "PlaylistManager",
  //     "CampaignManager",
  //     "CalendarManager",
  //     "Admin",
  //     "SuperAdmin"
  //   ],
  //   activeLink: "tickets",
  //   feature: "Ticket",
  //   title: "Ticket",
  //   icon: "fas fa-ticket-alt",
  //   path: "/tickets"
  // }
  /** -------------------- * */
  // {
  //   id: "r-10",
  //   roles: ["SuperAdmin"],
  //   activeLink: "metrics",
  //   feature: "Metrics",
  //   title: "Metrics",
  //   icon: "bx bx-tachometer",
  //   path: "/metrics"
  // }
];

function isActive(path = "", link = undefined) {
  if (path.search(link) >= 0) {
    return "active";
  }
  return "";
}
function HeaderLinkGenerator(props, onExitCampaignStudioFn) {
  let filteredLink = [];
  props.roles.map(role => {
    links.map(link => {
      if (link.roles.includes(role)) {
        filteredLink = [...filteredLink, link];
      }
    });
  });
  return sortBy(uniq(filteredLink), ["id"]).map(link => {
    if (props.match.path === "/campaign/studio") {
      return (
        <div
          className={`sidebar__nav__item ${isActive(
            props.match.path,
            link.activeLink
          )} nav-link`}
          onClick={() => onExitCampaignStudioFn(true, link)}
        >
          <span>
            <i className={`${link.icon} `} /> {link.title}
          </span>
        </div>
      );
    }
    return (
      <Link
        to={link.path}
        key={link.path}
        className={`sidebar__nav__item ${isActive(
          props.match.path,
          link.activeLink
        )} nav-link`}
      >
        <span>
          <i className={`${link.icon} `} /> {link.title}
        </span>
      </Link>
    );
  });
}

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSetting: false,
      class: "null",
      onExitCampaignStudio: false,
      link: undefined,
      isSubmittingReport: false,
      displaySideNav: false,
      searchVal: "",
      searchResultDrawer: false,
      isSearching: false,
      deviceRefetch: true,
      campaignRefetch: true,
      contentRefetch: true,
      playlistRefetch: true,
      calendarRefetch: true,
      userRefetch: true,
      deviceGroupPage: 1,
      contentPage: 1,
      campaignPage: 1,
      playlistPage: 1,
      calendarPage: 1,
      userPage: 1,
      activeTab: "devices",
      searchType: undefined
    };
    this.getAllNotification();
    this.getUserProfile();
  }

  componentDidMount() {
    if (this.props.authStatus) {
      Socket.connectWS(
        eventsEnum.NOTIFICATION,
        this.props.updateNotificationCountFromWebSocket
      );
      Socket.connectWS(
        eventsEnum.SEARCHEDDEVICE,
        this.props.updateGlobalSearchDeviceStatusWS
      );
    }
  }

  getAllNotification = () => {
    const { getNotifications } = notificationResources;
    getNotifications.url = `/notifications?page=${1}&per_page=${10}`;
    this.props.Get(getNotifications);
  };

  getUserProfile = () => {
    const { getUserProfileImage } = userResources;
    this.props.Get(getUserProfileImage);
  };

  handleSubmittingReport = flag => {
    this.setState({ isSubmittingReport: flag });
  };

  getNewTicketCounts = () => {
    const { newTicketsCount } = Resources;
    this.props.Get(newTicketsCount).then(response => {
      if (response.status === 200) {
        this.props.ticketUpdateFromWebsocket(response.data.ticket.count);
      }
    });
  };

  handleCampaignPageExit = (flag, link) => {
    this.setState({ onExitCampaignStudio: flag, link });
  };

  onClickSetting = () => {
    // document.getElementsByClassName("dropdown-content").style.display = "block";
    this.setState(prevState => ({
      showSetting: !prevState.showSetting
      // class: prevState.class === "null" ? "active" : "null"
    }));
  };

  handleConfirmNavigationClick = () => {
    this.props.history.push(this.state.link.path);
  };

  toggleSideNav = () => {
    this.setState(state => ({ displaySideNav: !state.displaySideNav }));
  };

  toggleTabs = activeTab => {
    this.setState({ activeTab });
  };

  handleSearchType = type => {
    this.setState({ searchType: type });
    if (type) {
      const activeTab = toLower(type);
      this.toggleTabs(activeTab);
    }
  };

  updateSearchValueAndPages = e => {
    this.setState({
      searchVal: e.target.value,
      isSearching: true,
      deviceGroupPage: 1,
      campaignPage: 1,
      contentPage: 1,
      playlistPage: 1,
      calendarPage: 1,
      userPage: 1
    });
  };

  handleSearchDeviceGlobally = debounce(() => {
    this.setState({ deviceRefetch: true });
    if (this.state.searchVal === "") {
      this.props.updateSearchResultData([]);
      this.setState({ isSearching: false });
      return 0;
    }
    const { globalSearch } = globalSearchResources;
    if (this.state.searchType === "DEVICES") {
      globalSearch.url = `global_search?search=${this.state.searchVal}&type=devices&devices_page=${this.state.deviceGroupPage}&per_page=10`;
    } else if (this.state.searchType === "CAMPAIGNS") {
      globalSearch.url = `global_search?search=${this.state.searchVal}&type=campaigns&campaigns_page=${this.state.campaignPage}&per_page=10`;
    } else if (this.state.searchType === "CONTENTS") {
      globalSearch.url = `global_search?search=${this.state.searchVal}&type=contents&contents_page=${this.state.contentPage}&per_page=10`;
    } else if (this.state.searchType === "PLAYLISTS") {
      globalSearch.url = `global_search?search=${this.state.searchVal}&type=playlists&playlists_page=${this.state.playlistPage}&per_page=10`;
    } else if (this.state.searchType === "CALENDARS") {
      globalSearch.url = `global_search?search=${this.state.searchVal}&type=calendars&calendars_page=${this.state.calendarPage}&per_page=10`;
    } else if (this.state.searchType === "USERS") {
      globalSearch.url = `global_search?search=${this.state.searchVal}&type=users&users_page=${this.state.userPage}&per_page=10`;
    } else {
      globalSearch.url = `global_search?search=${this.state.searchVal}&campaigns_page=${this.state.campaignPage}&devices_page=${this.state.deviceGroupPage}&contents_page=${this.state.contentPage}&playlists_page=${this.state.playlistPage}&calendars_page=${this.state.calendarPage}&users_page=${this.state.userPage}&per_page=10`;
    }
    this.props.Get(globalSearch).then(res => {
      if (res.status === 200) {
        this.setState({ isSearching: false });
        if (res.data.meta.deviceTotalPages <= res.data.meta.devicePage) {
          this.setState({ deviceRefetch: false });
        }
        if (res.data.meta.campaignTotalPages <= res.data.meta.campaignPage) {
          this.setState({ campaignRefetch: false });
        }
        if (res.data.meta.contentTotalPages <= res.data.meta.contentPage) {
          this.setState({ contentRefetch: false });
        }
        if (res.data.meta.playlistTotalPages <= res.data.meta.playlistPage) {
          this.setState({ playlistRefetch: false });
        }
        if (res.data.meta.calendarTotalPages <= res.data.meta.calendarPage) {
          this.setState({ calendarRefetch: false });
        }
        if (res.data.meta.userTotalPages <= res.data.meta.userPage) {
          this.setState({ userRefetch: false });
        }
      }
    });
  }, 3000);

  handleDeviceNext = () => {
    const { globalSearch } = globalSearchResources;
    if (this.state.searchVal === "") {
      return 0;
    }
    if (this.state.deviceRefetch) {
      this.setState(
        prevState => ({
          deviceGroupPage: prevState.deviceGroupPage + 1
        }),
        () => {
          if (this.state.searchType === "DEVICES") {
            globalSearch.url = `global_search?search=${this.state.searchVal}&type=devices&devices_page=${this.state.deviceGroupPage}&per_page=10`;
          } else {
            globalSearch.url = `global_search?search=${this.state.searchVal}&campaigns_page=${this.state.campaignPage}&devices_page=${this.state.deviceGroupPage}&contents_page=${this.state.contentPage}&playlists_page=${this.state.playlistPage}&calendars_page=${this.state.calendarPage}&users_page=${this.state.userPage}&per_page=10`;
          }
          this.props
            .Get(globalSearch)
            .then(response => {
              if (
                response.data.meta.deviceTotalPages <=
                response.data.meta.devicePage
              ) {
                this.setState({ deviceRefetch: false });
              }
            })
            .then(() => this.props.updateGroupInfiniteScroll());
        }
      );
    }
    return true;
  };

  handleCampaignNext = () => {
    const { globalSearch } = globalSearchResources;
    if (this.state.searchVal === "") {
      return 0;
    }
    if (this.state.campaignRefetch) {
      this.setState(
        prevState => ({
          campaignPage: prevState.campaignPage + 1
        }),
        () => {
          if (this.state.searchType === "CAMPAIGNS") {
            globalSearch.url = `global_search?search=${this.state.searchVal}&type=campaigns&campaigns_page=${this.state.campaignPage}&per_page=10`;
          } else {
            globalSearch.url = `global_search?search=${this.state.searchVal}&campaigns_page=${this.state.campaignPage}&devices_page=${this.state.deviceGroupPage}&contents_page=${this.state.contentPage}&playlists_page=${this.state.playlistPage}&calendars_page=${this.state.calendarPage}&users_page=${this.state.userPage}&per_page=10`;
          }
          this.props
            .Get(globalSearch)
            .then(response => {
              if (
                response.data.meta.campaignTotalPages <=
                response.data.meta.campaignPage
              ) {
                this.setState({ campaignRefetch: false });
              }
            })
            .then(() => this.props.updateCampaignInfiniteScroll());
        }
      );
    }
    return true;
  };

  handleContentNext = () => {
    const { globalSearch } = globalSearchResources;
    if (this.state.searchVal === "") {
      return 0;
    }
    if (this.state.contentRefetch) {
      this.setState(
        prevState => ({
          contentPage: prevState.contentPage + 1
        }),
        () => {
          if (this.state.searchType === "CONTENTS") {
            globalSearch.url = `global_search?search=${this.state.searchVal}&type=contents&contents_page=${this.state.contentPage}&per_page=10`;
          } else {
            globalSearch.url = `global_search?search=${this.state.searchVal}&campaigns_page=${this.state.campaignPage}&devices_page=${this.state.deviceGroupPage}&contents_page=${this.state.contentPage}&playlists_page=${this.state.playlistPage}&calendars_page=${this.state.calendarPage}&users_page=${this.state.userPage}&per_page=10`;
          }
          this.props
            .Get(globalSearch)
            .then(response => {
              if (
                response.data.meta.contentTotalPages <=
                response.data.meta.contentPage
              ) {
                this.setState({ contentRefetch: false });
              }
            })
            .then(() => this.props.updateContentInfiniteScroll());
        }
      );
    }
    return true;
  };

  handlePlaylistNext = () => {
    const { globalSearch } = globalSearchResources;
    if (this.state.searchVal === "") {
      return 0;
    }
    if (this.state.playlistRefetch) {
      this.setState(
        prevState => ({
          playlistPage: prevState.playlistPage + 1
        }),
        () => {
          if (this.state.searchType === "PLAYLISTS") {
            globalSearch.url = `global_search?search=${this.state.searchVal}&type=playlists&playlists_page=${this.state.playlistPage}&per_page=10`;
          } else {
            globalSearch.url = `global_search?search=${this.state.searchVal}&campaigns_page=${this.state.campaignPage}&devices_page=${this.state.deviceGroupPage}&contents_page=${this.state.contentPage}&playlists_page=${this.state.playlistPage}&calendars_page=${this.state.calendarPage}&users_page=${this.state.userPage}&per_page=10`;
          }
          this.props
            .Get(globalSearch)
            .then(response => {
              if (
                response.data.meta.playlistTotalPages <=
                response.data.meta.playlistPage
              ) {
                this.setState({ playlistRefetch: false });
              }
            })
            .then(() => this.props.updatePlaylistInfiniteScroll());
        }
      );
    }
    return true;
  };

  handleCalendarNext = () => {
    const { globalSearch } = globalSearchResources;
    if (this.state.searchVal === "") {
      return 0;
    }
    if (this.state.calendarRefetch) {
      this.setState(
        prevState => ({
          calendarPage: prevState.calendarPage + 1
        }),
        () => {
          if (this.state.searchType === "CALENDARS") {
            globalSearch.url = `global_search?search=${this.state.searchVal}&type=calendars&calendars_page=${this.state.calendarPage}&per_page=10`;
          } else {
            globalSearch.url = `global_search?search=${this.state.searchVal}&campaigns_page=${this.state.campaignPage}&devices_page=${this.state.deviceGroupPage}&contents_page=${this.state.contentPage}&playlists_page=${this.state.playlistPage}&calendars_page=${this.state.calendarPage}&users_page=${this.state.userPage}&per_page=10`;
          }
          this.props
            .Get(globalSearch)
            .then(response => {
              if (
                response.data.meta.calendarTotalPages <=
                response.data.meta.calendarPage
              ) {
                this.setState({ calendarRefetch: false });
              }
            })
            .then(() => this.props.updateCalendarInfiniteScroll());
        }
      );
    }
    return true;
  };

  handleUserNext = () => {
    const { globalSearch } = globalSearchResources;
    if (this.state.searchVal === "") {
      return 0;
    }
    if (this.state.userRefetch) {
      this.setState(
        prevState => ({
          userPage: prevState.userPage + 1
        }),
        () => {
          if (this.state.searchType === "USERS") {
            globalSearch.url = `global_search?search=${this.state.searchVal}&type=users&users_page=${this.state.userPage}&per_page=10`;
          } else {
            globalSearch.url = `global_search?search=${this.state.searchVal}&campaigns_page=${this.state.campaignPage}&devices_page=${this.state.deviceGroupPage}&contents_page=${this.state.contentPage}&playlists_page=${this.state.playlistPage}&calendars_page=${this.state.calendarPage}&users_page=${this.state.userPage}&per_page=10`;
          }
          this.props
            .Get(globalSearch)
            .then(response => {
              if (
                response.data.meta.userTotalPages <= response.data.meta.userPage
              ) {
                this.setState({ userRefetch: false });
              }
            })
            .then(() => this.props.updateUserInfiniteScroll());
        }
      );
    }
    return true;
  };

  handleDisplaySearchDrawer = flag => {
    if (!flag) {
      this.setState({
        searchVal: "",
        searchType: undefined,
        activeTab: "devices"
      });
      this.props.updateSearchResultData([]);
    } else {
      setTimeout(() => {
        this.myInp.focus();
      }, 400);
    }
    this.setState({
      searchResultDrawer: flag,
      isSearching: false
    });
  };

  render() {
    const isSuperAdmin = this.props.roles.includes("SuperAdmin");
    const isAdmin = this.props.roles.includes("Admin");
    const domain = JSON.parse(window.localStorage.getItem("domain")).name;
    const { displaySideNav, activeTab } = this.state;
    return (
      /* -- The sidebar -- */
      <div>
        <div
          id="mainSideBar"
          className={`sidebar ${
            displaySideNav ? "displaySideBar" : "hideSideBar"
          }`}
        >
          <div className="sidebarWrapper">
            <DesktopBreakpoint>
              <img src={require("../../assets/images/logo.svg")} alt="IMG" />
            </DesktopBreakpoint>
            {displaySideNav && (
              <i
                className="fa fa-times timesIcon"
                onClick={this.toggleSideNav}
              />
            )}
            <Nav vertical className="sidebar__nav">
              {HeaderLinkGenerator(this.props, this.handleCampaignPageExit)}
            </Nav>
          </div>
        </div>
        {/* ---- end of sidebar ---- */}
        {/* ---- The main page ---- */}
        <div className="mainPage">
          <div className="d-flex fixed-top header mainHeader">
            <PhoneBreakpoint>
              <i
                className="bx bx-menu"
                style={{
                  fontSize: "28px",
                  paddingTop: "16px",
                  paddingLeft: "16px"
                }}
                onClick={this.toggleSideNav}
              />
            </PhoneBreakpoint>
            <div className="mr-auto">
              <DesktopBreakpoint>
                <CustomBreadcrumb {...this.props} />
              </DesktopBreakpoint>
            </div>

            {/** commenting ticket code for certain time being  * */}
            {/* <TicketNotification {...this.props} /> */}
            {isSuperAdmin && (
              <div className="header-search">
                <PhoneBreakpoint>
                  <div
                    role="presentation"
                    className="headerSearchIconForMobile"
                    onClick={() => this.handleDisplaySearchDrawer(true)}
                  >
                    <i className=" bx bx-search bx-sm " />
                  </div>
                </PhoneBreakpoint>
                <DesktopBreakpoint>
                  {/* <div className="search__searchIcon">
                    <span className="bx bx-search bx-sm " width="100%" />
                    <span>{this.state.searchType}</span>
                  </div> */}
                  <div className="searchWrapper">
                    <span
                      className="bx bx-search bx-sm searchIcon "
                      width="100%"
                    />
                    {this.state.searchType && (
                      <span className="searchType">
                        {this.state.searchType}
                        <i
                          className="fas fa-times"
                          role="presentation"
                          onClick={() => this.handleSearchType(undefined)}
                        />
                      </span>
                    )}
                    <input
                      type="text"
                      ref={ip => {
                        this.myInp = ip;
                      }}
                      onClick={() => this.handleDisplaySearchDrawer(true)}
                      className=""
                      placeholder="Search "
                      onChange={e => {
                        this.updateSearchValueAndPages(e);
                        this.handleSearchDeviceGlobally();
                      }}
                      value={this.state.searchVal}
                    />
                  </div>
                </DesktopBreakpoint>
                {/* <div className="custom-drawer">Hello</div> */}
              </div>
            )}

            {isSuperAdmin && <DeviceMetricsNotification {...this.props} />}
            <div className=" text-dark user-profile-avatar">
              <LoginDesc
                domain={domain}
                isSuperAdmin={isSuperAdmin}
                isAdmin={isAdmin}
                Logout={this.props.Logout}
                user={this.props.user}
                userProfileImage={this.props.userProfileImage}
                Post={this.props.Post}
                showNotification={this.props.showNotification}
                handleSubmittingReport={this.handleSubmittingReport}
                isSubmittingReport={this.state.isSubmittingReport}
              />
            </div>
          </div>
        </div>
        <ExitCampaignStudio
          onExitCampaignStudio={this.state.onExitCampaignStudio}
          handleCampaignPageExit={this.handleCampaignPageExit}
          handleConfirmNavigationClick={this.handleConfirmNavigationClick}
          history={this.props.history}
        />

        {this.state.isSubmittingReport && (
          <div>
            <div
              id="notification_toast-flash"
              className="notification_toast info animated fadeInUp"
            >
              <p>
                Submitting <i className="fa fa-spinner fa-spin" />
              </p>
            </div>
          </div>
        )}
        {isSuperAdmin && (
          <Drawer
            className="overlay-drawer search-drawer"
            open={this.state.searchResultDrawer}
            // onClose={() => this.props.toggledeviceControlModal("cancel")}
            onClose={this.onTouchEnd}
            handler={false}
            level={null}
            placement="right"
            showMask
            onMaskClick={() => {
              this.handleDisplaySearchDrawer(false);
            }}
          >
            <div
              style={{
                position: "sticky",
                top: 0,
                zIndex: "3000",
                backgroundColor: "#ffffff",
                width: "100%"
              }}
            >
              <PhoneBreakpoint>
                <div className="mt-2 mr-0 mb-2 header-search">
                  <div className="searchWrapper searchWrapper--mod">
                    <span
                      className="bx bx-search bx-sm searchIcon "
                      width="100%"
                    />
                    {this.state.searchType && (
                      <span className="searchType">
                        {this.state.searchType}
                        <i
                          className="fas fa-times"
                          role="presentation"
                          onClick={() => this.handleSearchType(undefined)}
                        />
                      </span>
                    )}
                    <input
                      type="text"
                      ref={ip => {
                        this.myInp = ip;
                      }}
                      onClick={() => this.handleDisplaySearchDrawer(true)}
                      placeholder="Search"
                      onChange={e => {
                        this.updateSearchValueAndPages(e);
                        this.handleSearchDeviceGlobally();
                      }}
                      value={this.state.searchVal}
                    />
                  </div>
                </div>
              </PhoneBreakpoint>
              <span className="campaignDetail__information searchlist-container mt-0">
                Search Results{" "}
                {this.state.searchVal && (
                  <span>
                    for
                    <strong> {`" ${this.state.searchVal} "`} </strong>
                  </span>
                )}{" "}
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => this.handleDisplaySearchDrawer(false)}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </span>
            </div>
            {this.props.searchResults.length > 0 ? (
              <div>
                <Nav tabs className="mb-3">
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "devices"
                      })}
                      onClick={() => {
                        this.toggleTabs("devices");
                      }}
                    >
                      Devices{" "}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "campaigns"
                      })}
                      onClick={() => {
                        this.toggleTabs("campaigns");
                      }}
                    >
                      Campaigns
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "contents"
                      })}
                      onClick={() => {
                        this.toggleTabs("contents");
                      }}
                    >
                      Contents
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "playlists"
                      })}
                      onClick={() => {
                        this.toggleTabs("playlists");
                      }}
                    >
                      Playlists
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "calendars"
                      })}
                      onClick={() => {
                        this.toggleTabs("calendars");
                      }}
                    >
                      Calendars
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "users"
                      })}
                      onClick={() => {
                        this.toggleTabs("users");
                      }}
                    >
                      Users
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={activeTab}>
                  <TabPane tabId="devices" className="fullHeightForMobile">
                    {" "}
                    <GlobalSearchDevice
                      refetch={this.state.deviceRefetch}
                      handleNext={this.handleDeviceNext}
                      isSearching={this.state.isSearching}
                      searchVal={this.state.searchVal}
                      searchResults={this.props.deviceSearchResult}
                    />
                  </TabPane>
                </TabContent>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="campaigns" className="fullHeightForMobile">
                    <GlobalSearchCampaign
                      refetch={this.state.campaignRefetch}
                      handleNext={this.handleCampaignNext}
                      isSearching={this.state.isSearching}
                      searchVal={this.state.searchVal}
                      searchResults={this.props.campaignSearchResult}
                    />
                  </TabPane>
                </TabContent>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="contents" className="fullHeightForMobile">
                    <GlobalSearchContent
                      refetch={this.state.contentRefetch}
                      handleNext={this.handleContentNext}
                      isSearching={this.state.isSearching}
                      searchVal={this.state.searchVal}
                      searchResults={this.props.contentSearchResult}
                    />
                  </TabPane>
                </TabContent>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="playlists" className="fullHeightForMobile">
                    <GlobalSearchPlaylist
                      refetch={this.state.playlistRefetch}
                      handleNext={this.handlePlaylistNext}
                      isSearching={this.state.isSearching}
                      searchVal={this.state.searchVal}
                      searchResults={this.props.playlistSearchResult}
                    />
                  </TabPane>
                </TabContent>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="calendars" className="fullHeightForMobile">
                    <GlobalSearchCalendar
                      refetch={this.state.calendarRefetch}
                      handleNext={this.handleCalendarNext}
                      isSearching={this.state.isSearching}
                      searchVal={this.state.searchVal}
                      searchResults={this.props.calendarSearchResult}
                    />
                  </TabPane>
                </TabContent>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="users" className="fullHeightForMobile">
                    <GlobalSearchUser
                      refetch={this.state.userRefetch}
                      handleNext={this.handleUserNext}
                      isSearching={this.state.isSearching}
                      searchVal={this.state.searchVal}
                      searchResults={this.props.userSearchResult}
                    />
                  </TabPane>
                </TabContent>
              </div>
            ) : (
              <div>
                {this.state.isSearching ? (
                  <div className="searchResultContainerSearch">
                    <div>
                      Searching <i className="fa fa-spinner fa-spin" />
                    </div>
                  </div>
                ) : (
                  <div className="searchResultContainer">
                    {" "}
                    <div className="searchResultContents">
                      <div className="ml-auto mr-auto searchIconWrapper mb-3">
                        <i className="fas fa-search searchIcon" />
                      </div>
                      <div
                        style={{ marginLeft: "10px" }}
                        className="searchResult-text"
                      >
                        What are you searching for?
                      </div>
                      <div className="searchResult-noData d-flex flex-wrap">
                        <div className="mt-3">
                          <button
                            className="ml-0 mt-3 btn-outline-primary"
                            onClick={() => this.handleSearchType("DEVICES")}
                          >
                            Devices
                          </button>{" "}
                          <button
                            className="ml-0 mt-3 btn-outline-primary"
                            onClick={() => this.handleSearchType("CAMPAIGNS")}
                          >
                            Campaigns
                          </button>
                          <button
                            className="ml-0 mt-3 btn-outline-primary"
                            onClick={() => this.handleSearchType("CONTENTS")}
                          >
                            Contents
                          </button>
                          <button
                            className="ml-0 mt-3 btn-outline-primary"
                            onClick={() => this.handleSearchType("PLAYLISTS")}
                          >
                            Playlists
                          </button>
                          <button
                            className="ml-0 mt-3 btn-outline-primary"
                            onClick={() => this.handleSearchType("CALENDARS")}
                          >
                            Calendars
                          </button>
                          <button
                            className="ml-0 mt-3 mr-0 btn-outline-primary"
                            onClick={() => this.handleSearchType("USERS")}
                          >
                            Users
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </Drawer>
        )}
        <PhoneBreakpoint>
          <div className="mobileBreadCrumb">
            <CustomBreadcrumb {...this.props} />
          </div>{" "}
        </PhoneBreakpoint>
        {/* --- end of main page --- */}
      </div>
    );
  }
}
function mapState(state) {
  const { campaign } = state.newCampaign;

  return {
    user: state.userDetails.user,
    userProfileImage:
      state.userProfileImage.list && state.userProfileImage.list.attributes,
    headerReload: state.reloadHeader,
    campaign,
    searchResults: state.globalSearchResults.list || [],
    deviceSearchResult:
      (state.globalSearchResults.list &&
        state.globalSearchResults.list.length > 0 &&
        state.globalSearchResults.list[0].devices) ||
      [],
    campaignSearchResult:
      (state.globalSearchResults.list &&
        state.globalSearchResults.list.length > 0 &&
        state.globalSearchResults.list[0].campaigns) ||
      [],
    contentSearchResult:
      (state.globalSearchResults.list &&
        state.globalSearchResults.list.length > 0 &&
        state.globalSearchResults.list[0].contents) ||
      [],
    playlistSearchResult:
      (state.globalSearchResults.list &&
        state.globalSearchResults.list.length > 0 &&
        state.globalSearchResults.list[0].playlists) ||
      [],
    calendarSearchResult:
      (state.globalSearchResults.list &&
        state.globalSearchResults.list.length > 0 &&
        state.globalSearchResults.list[0].calendars) ||
      [],
    userSearchResult:
      (state.globalSearchResults.list &&
        state.globalSearchResults.list.length > 0 &&
        state.globalSearchResults.list[0].users) ||
      []
  };
}
const Headers = connect(
  mapState,
  {
    Logout,
    Get,
    ticketUpdateFromWebsocket,
    Post,
    showNotification,
    updateSearchResultData,
    updateGroupInfiniteScroll,
    updateNotificationCountFromWebSocket,
    updateGlobalSearchDeviceStatusWS,
    updateCampaignInfiniteScroll,
    updateContentInfiniteScroll,
    updatePlaylistInfiniteScroll,
    updateCalendarInfiniteScroll,
    updateUserInfiniteScroll
  }
)(Header);
export { Headers };
